module.exports = __webpack_public_path__ + "assets/img/1271587028503_.pic_hd.c3077738.jpg";